<template>
  <div class="cardList" :class="[size]">
    <template v-if="list.length">
      <div class="cardItem" v-for="item in list" :key="item.recommendId">
        <div class="cardItemLeft">
          <img :src="item.picPath" alt="" />
        </div>
        <div class="cardItemCenter">
          <div class="cardItemTitle">
            <span class="label" :class="['type' + item.productType]">
              {{ item.productType === '1' ? '互联网转投' : '在线投保' }}
            </span>
            <span class="title" :title="item.productName">{{ item.productName }}</span>
          </div>
          <div class="cardItemSubTitle">{{ item.subTitle }}</div>
          <swiper class="cardItemLabels" v-if="item.label" :options="swiperOptions">
            <swiper-slide v-for="inner in item.label.split(',')" :key="inner">
              <span @click.stop>{{ inner }}</span>
            </swiper-slide>
          </swiper>
          <div class="cardItemRules">
            <span>投保年龄：{{ item.insureAge }}</span>
            <span>保障期间：{{ item.insurePeriod }}</span>
          </div>
        </div>
        <div class="cardItemRight">
          <p class="cardItemPrice">
            <span>{{ item.insurancePremium | toFixed }}</span> 元起
          </p>
          <el-button type="primary" @click="handleDetails(item)">查看详情</el-button>
        </div>
      </div>
    </template>
    <p v-else class="cardListNull">暂无相关产品</p>
  </div>
</template>

<script>
export default {
  props: {
    list: { type: Array, default: () => [] },
    size: { type: String, default: 'normal' },
  },
  data() {
    return {
      swiperOptions: {
        grabCursor: true,
        slidesPerView: 'auto',
        width: 'auto',
        freeMode: true,
      },
    };
  },
  methods: {
    // 跳转推荐产品详情
    handleDetails({ recommendId, productType, consultantProductId }) {
      this.$router.push({ name: 'recommendDetails', query: { recommendId, productType, consultantProductId } });
    },
  },
};
</script>

<style lang="less" scoped>
.cardList {
  .cardItem {
    display: flex;
    border: 1px solid #dcdce1;
    transition: 0.5s;
    &:hover {
      box-shadow: 10px 10px 10px 0 #eee;
      .cardItemLeft img {
        transform: scale(1.05);
      }
    }
    &:not(:last-of-type) {
      margin-bottom: 25px;
    }
    .cardItemLeft {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 230px;
      height: 230px;
      margin-right: 30px;
      overflow: hidden;
      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
        transition: 0.5s;
      }
    }
    .cardItemCenter {
      flex: 1;
      width: 0;
      margin-right: 70px;
      padding-top: 30px;
      font-size: 22px;
      .cardItemTitle {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 15px;
        .label {
          width: 96px;
          margin-right: 10px;
          font-size: 19px;
          line-height: 30px;
          color: #fff;
          border-radius: 4px;
          text-align: center;
          &.type1 {
            background: #e27c00 linear-gradient(180deg, #0d7ae2 0%, #7cb3fa 100%);
          }
          &.type2 {
            background: #e27c00 linear-gradient(180deg, #e27d01 0%, #f7b334 99%);
          }
        }
        .title {
          overflow: hidden;
          font-size: 28px;
          font-weight: bold;
          color: #382e2b;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .cardItemSubTitle {
        overflow: hidden;
        margin-bottom: 20px;
        color: #d3d3d9;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .cardItemLabels {
        margin-bottom: 15px;
        .swiper-slide {
          width: auto;
          padding: 3px 4px;
          color: #e27c00;
          background: #fcf2e4;
          &:not(:last-of-type) {
            margin-right: 8px;
          }
        }
      }
      .cardItemRules {
        display: flex;
        color: #aaa;
        span {
          margin-right: 30px;
        }
      }
    }
    .cardItemRight {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-around;
      width: 240px;
      padding: 40px 0;
      .cardItemPrice {
        font-size: 22px;
        color: #333;
        span {
          font-size: 32px;
          font-weight: bold;
          color: #f33;
        }
      }
      .el-button {
        width: 160px;
        height: 50px;
        font-size: 22px;
        border-radius: 25px;
      }
    }
  }
  // 列表页 样式尺寸偏小
  &.small {
    .cardItemLeft {
      width: 185px;
      height: 185px;
      margin-right: 20px;
    }
    .cardItemCenter {
      margin-right: 0;
      padding-top: 20px;
      font-size: 18px;
    }
    .cardItemRight {
      .cardItemPrice {
        font-size: 18px;
        span {
          font-size: 29px;
        }
      }
    }
  }
  .cardListNull {
    text-align: center;
    margin-top: 15px;
    font-size: 18px;
    color: #aaa;
  }
}
</style>
